import * as React from 'react';
import Barcodes from '../barcode/Barcodes';
import AuxiliaryFields from '../fields/AuxiliaryFields';
import SecondaryFields from '../fields/SecondaryFields';
import LogoLogoTextHeaderFields from './LogoTextHeaderFields';
import { usePkpass } from '../usePkpass';
import BoardingPassIcon from './BoardingPassIcon';
import { PkpassFieldsType } from '../../../../types';
import { createUseStyles } from 'react-jss';
import { useTheme } from '../../Theme';
import Field from '../fields/field/preview/Field';
export const useStyles = createUseStyles({
  containerBoardingPass: {
    display: 'table',
    height: ({
      theme
    }) => theme.scale * 70,
    tableLayout: 'fixed',
    width: ({
      theme
    }) => theme.scale * 320
  },
  fieldContainer: {
    display: 'table-cell',
    verticalAlign: 'top'
  },
  iconContainer: {
    display: 'table-cell',
    textAlign: 'center',
    verticalAlign: 'middle',
    width: ({
      theme
    }) => theme.scale * 70,
    '&:hover': {
      cursor: ({
        clickable
      }) => clickable ? 'pointer' : undefined,
      opacity: ({
        clickable
      }) => clickable ? 0.7 : undefined
    }
  }
});

const BoardingPass = () => {
  const {
    pass,
    onBoardingPassIconClick
  } = usePkpass();
  const theme = useTheme();
  const classes = useStyles({
    theme,
    clickable: !!onBoardingPassIconClick
  });
  const primaryFields = pass.boardingPass.primaryFields || [];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LogoLogoTextHeaderFields, null), /*#__PURE__*/React.createElement("div", {
    className: classes.containerBoardingPass
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.fieldContainer
  }, primaryFields.length > 0 && /*#__PURE__*/React.createElement(Field, {
    fieldsType: PkpassFieldsType.PrimaryFields,
    fieldIndex: 0,
    align: "left"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.iconContainer,
    onClick: onBoardingPassIconClick
  }, /*#__PURE__*/React.createElement(BoardingPassIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: classes.fieldContainer
  }, primaryFields.length > 1 && /*#__PURE__*/React.createElement(Field, {
    fieldsType: PkpassFieldsType.PrimaryFields,
    fieldIndex: 1,
    align: "right"
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AuxiliaryFields, null), /*#__PURE__*/React.createElement(SecondaryFields, null)), /*#__PURE__*/React.createElement(Barcodes, null));
};

export default BoardingPass;
//# sourceMappingURL=BoardingPass.js.map